import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-status-message',
    templateUrl: './status-message.component.html',
    styleUrls: ['./status-message.component.css'],
    standalone: false
})
export class StatusMessageComponent {
  @Input() messageText: string = 'Operation completed successfully';
  @Input() messageType: 'error' | 'success' | 'warning' = 'success';
  @Output() closeLinkClick: EventEmitter<string> = new EventEmitter<string>();

  isVisible: boolean = true;

  dismissMessage(): void {
    this.isVisible = false;
  }
  closeLink(): void {
    this.closeLinkClick.emit();
  }
}